import { Component, OnInit, Injectable, Inject } from '@angular/core';
import { CancelRefundService } from 'src/app/services/rest-api/cancel-refund.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { RefundEligibilityLiteRq } from 'src/app/models/RefundEligibilityLiteRq';
import { RefundReviewRq } from 'src/app/models/RefundReviewRq';
import { TripType } from 'src/app/models/TripType';
import { TranslatorService } from 'src/app/modules/translator/providers/translator.service';
import { InterpolationService } from 'src/app/services/utils/interpolation.service';
import { WINDOW } from 'src/app/models/WindowProvider';
import { RefundEligibilityReason } from 'src/app/models/RefundEligibilityReason';
import { Location } from '@angular/common';
import { TealiumUtagService } from 'src/app/tealium/utag.service';
import { WebAnalyticsUTagData } from 'src/app/tealium/WebAnalyticsUTagData';
import { AnalyticsHandlerService } from 'src/app/tealium/analytics-handler';

@Component({
  selector: 'app-cancel-refund',
  templateUrl: './cancel-refund.component.html',
  styleUrls: ['./cancel-refund.component.css'],
  providers: [TealiumUtagService]
})

// @Injectable()
export class CancelRefundComponent implements OnInit {

  // ticketingTime: string;
  hoursLeft: number;
  minutesLeft: number;
  secondsLeft: number;

  refundEligibilityLiteRqJSON: string;
  refundEligibilityLiteRq: RefundEligibilityLiteRq;
  refundCacheID: string;
  refundReviewRq: RefundReviewRq;
  TripType = TripType;
  isLoading = true;
  isEligible: Promise<boolean>;
  is24HR = false;

  // public translations: any;
  public pageData: any;

  utagData: WebAnalyticsUTagData = new WebAnalyticsUTagData();
  clicked: boolean;

  constructor(private cancelRefundService: CancelRefundService,
              private route: ActivatedRoute,
        //      private timeoutManagerService: SessionTimeoutManagerService,
              private translatorService: TranslatorService,
              private interpolatorService: InterpolationService,
              @Inject(WINDOW) private window: Window,
              private utagService: TealiumUtagService,
              private analyticsHandler: AnalyticsHandlerService) {
                this.utagService.setConfig(this.analyticsHandler.getTealiumConfigs());
              }

  getHostname(): string {
    return this.window.location.hostname;
  }

  ngOnInit() {
    this.getPageData();
 //   this.timeoutManagerService.startTimeoutCounter();
   // this.timeoutManagerService.restartTimeout();
    // trying to get activated route path param from route snapshot [works in certain version(s)]
    this.refundEligibilityLiteRqJSON = this.route.snapshot.params.refundEligibilityLiteRqJSON;
    this.refundCacheID = this.route.snapshot.params.refundEligibilityLiteRqJSON;
    // trying to get activated route path param from route queryParams [works in certain version(s)]
    this.route.queryParams.subscribe(params => {
        if (typeof this.refundEligibilityLiteRqJSON === 'undefined') {
        this.refundEligibilityLiteRqJSON = params.refundEligibilityLiteRqJSON;
        }
        if (typeof this.refundCacheID === 'undefined') {
        this.refundCacheID = params.refundEligibilityLiteRqJSON;
        }
    });
    // trying to get activated route path param from route fragment [works in certain version(s)]
    this.route.fragment.subscribe(value => {
        if (typeof this.refundEligibilityLiteRqJSON === 'undefined') {
        this.refundEligibilityLiteRqJSON = value?.substr('/cancelrefund/'.length);
        }
        if (typeof this.refundCacheID === 'undefined') {
        this.refundCacheID = value?.substr('/cancelrefund/'.length);
        }
    });
    this.cancelRefundService.isEligible(this.refundCacheID)
    .pipe(
        tap(val => {
        this.refundReviewRq = this.cancelRefundService.getRefundReviewRq();
        setInterval(() => {
            this.timeLeftToCancelAndRefund(String(this.refundReviewRq.timeToCancel));
        }, 1000);
        if (this.refundReviewRq.eligibilityReason === RefundEligibilityReason.TWENTY_FOUR_HOUR_REFUND_ELIGIBLE) {
            this.is24HR = true;
        }
        })
    )
    .subscribe((val) => {
        console.log('isEligible POST call successful, eligibility returned...',
        val);
        this.isLoading = false;
        this.populateTealiumData();
        // tealium send metrics
        const sUtagData: string = JSON.stringify(this.utagData);
        // s_utag_data = s_utag_data.substring(1, s_utag_data.length-1);
        console.log('s_utag_data is ', sUtagData);
        // this.tealium.track("view", s_utag_data);
        this.utagService.track('view', this.utagData);
        this.processCancelRefundComponent(val);
    },
        response => {
        this.handleError();
        },
        () => {
        });
    setInterval(() => {
    }, 1000);
  }

  private getPageData() {
    const dataSet = new Map();
    this.pageData = this.interpolatorService
                        .interpolate(this.translatorService
                                    .getTranslations('cancel-refund'),
                                    dataSet);
  }

  timeLeftToCancelAndRefund(timeToCancel: string) {
    const startTime: Date = new Date();
    const endTime: Date = new Date(timeToCancel);
    const total24HRMins: number = 24 * 60 * 60 * 1000;
    const diffInMillis: number = (Math.abs(startTime.getTime() - endTime.getTime()));
    const seconds: number = Math.floor((diffInMillis / 1000) % 60);
    const minutes: number = Math.floor((diffInMillis / (1000 * 60)) % 60);
    const hours: number = Math.floor((diffInMillis / (1000 * 60 * 60)));
    this.hoursLeft = hours;
    this.minutesLeft = minutes;
    this.secondsLeft = seconds;
  }

  processCancelRefundComponent(isEligible: boolean) {
    console.log('processing cancel..');
    this.isEligible = Promise.resolve(isEligible);
    if (!isEligible) {
        this.cancelRefundService.ineligible().subscribe((val) => {
        console.log('GET call successful, ineligible endpoint returned... ',
            val);
        window.location.href = 'https://' + this.getHostname() + val;
        },
        response => {
            console.log('GET call for ineligible endpoint in error...');
            this.handleError();
        },
        () => {
            console.log('The GET observable for ineligible endpoint is now completed.');
        });
    }
  }

  goBack() {
    // this.location.back();
    this.cancelRefundService.goBack().subscribe((val) => {
        console.log('GET call successful, goBack endpoint returned ',
        val);
        window.location.href = 'https://' + this.getHostname() + val;
    },
        response => {
        console.log('GET call for goBack endpoint in error');
        this.handleError();
        },
        () => {
        console.log('The GET observable for goBack endpoint is now completed.');
        console.log('The GET observable for goBack endpoint is now completed.');
        });
  }

  cancelForRefund() {
    this.isLoading = true;
    this.cancelRefundService.cancelForRefund().subscribe((val) => {
        console.log('POST refund submit call successful, response returned... ',
        val);
        window.location.href = 'https://' + this.getHostname() + val;
        this.isLoading = false;
    },
        response => {
        console.log('POST call for refund submit in error');
        this.goBack();
        this.isLoading = false;
        },
        () => {
        console.log('The POST observable for refund submit is now completed.');
        });
  }

  setTealiumEnvironment() {
    this.cancelRefundService.environment().subscribe((val) => {
        console.log('GET call successful, environment returned ',
        val);
        this.utagData.tealium_environment = val;
    },
        response => {
        console.log('GET call for environment resulted in error');
        this.handleError();
        },
        () => {
        console.log('The GET observable for environment is now completed.');
        });
  }

  setLoginStatus() {
    this.cancelRefundService.loginStatus(this.getHostname()).subscribe((val) => {
        console.log('GET call successful, loginStatus returned ',
        val);
        if ('0' === val.status) {
        this.utagData.login_status = 'Logged_out';
        } else if ('1' === val.status) {
        this.utagData.login_status = 'Soft_Login';
            } else if ('2' === val.status) {
        this.utagData.login_status = 'Logged_in';
            } else {
        this.utagData.login_status = 'Logged_out';
            }
    },
        response => {
        console.log('GET call for loginStatus resulted in error');
        this.handleError();
        },
        () => {
        console.log('The GET observable for loginStatus is now completed.');
        });
  }

  setLoyaltyMemberInfo() {
    this.cancelRefundService.loyaltyMemberInfo(this.getHostname()).subscribe((val) => {
        console.log('GET call successful, loginStatus returned ',
        val);
        this.utagData.loyalty_balance = val.awardMiles.value.replace(',', '');
        this.utagData.loyalty_id = val.aadvantageNumber;
        this.utagData.loyalty_tier = val.tierLevel;
    },
        response => {
        console.log('GET call for loginStatus resulted in error');
        this.utagData.loyalty_balance = '';
        this.utagData.loyalty_id = '';
        this.utagData.loyalty_tier = '';
        },
        () => {
        console.log('The GET observable for loginStatus is now completed....');
        });
  }

  handleError() {
    this.cancelRefundService.error().subscribe((val) => {
        console.log('GET call successful, error endpoint returned ',
        val);
        window.location.href = 'https://' + this.getHostname() + ':4200' + val;
    },
        response => {
        console.log('GET call for error endpoint in error...');
        },
        () => {
        console.log('The GET observable for error endpoint is now completed....');
        });
  }

  populateTealiumData() {
    // populate the utag_data - start
    this.utagData.pnr = this.refundReviewRq.recordLocator;
    // this.utag_data.pnr_booked_date = this.refundReviewRq.bookingDate;
    let pnrBookedDateStr: string = this.refundReviewRq.bookingDate + '';
    pnrBookedDateStr = pnrBookedDateStr.split('T')[0];
    const pnrBookedDateTokens = pnrBookedDateStr.split('-');
    // this.utagData.pnrBookedDate = pnrBookedDateTokens[1] + '/' + pnrBookedDateTokens[2] + '/' + pnrBookedDateTokens[0];
    this.utagData.channel = 'View Res';
    // this.utag_data.error_id = '';
    // this.utag_data.login_status = '';
    this.setLoginStatus();
    this.utagData.page_name = 'Self Service Refund- 24 Hr';
    this.utagData.server = 'ngrefund-web-ui';
    const locale: string = localStorage.getItem('locale');
    const locales = locale.split('_');
    this.utagData.site_country = locales[1];
    this.utagData.site_indicator = 'AAcom';
    this.utagData.site_language = locales[0].toUpperCase();
    // this.utag_data.tealium_environment = 'qa';
    // obtain and populate the environment in utag_data for tealium
    this.setTealiumEnvironment();
    this.utagData.tealium_profile = 'main';
    const d = new Date();
    this.utagData.time_stamp = this.checkZero((d.getMonth() + 1)) + '/' +
        this.checkZero(d.getDate()) + '/' +
        this.checkZero(d.getFullYear()) + ' ' +
        this.checkZero(d.getHours()) + ':' +
        this.checkZero(d.getMinutes()) + ':' +
        this.checkZero(d.getSeconds());
    // this.utag_data.time_stamp = new Date();
        // this.utag_data.partner_code_info = '';
        // this.utag_data.gd_treatment_code = '';
        // this.utag_data.loyalty_balance = '';
        // this.utag_data.loyalty_id = '';
        // this.utag_data.loyalty_tier = '';
    this.setLoyaltyMemberInfo();
        // populate the utag_data - end
  }

  checkZero(data) {
    data = data + '';
    if (data.length === 1) {
        data = '0' + data;
    }
    return data;
  }

}
